import React, { useEffect, useState, useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { createForm } from 'rc-form';
import { getCollectConfig } from '@chat/utils';
import { IMSTATUS, MsgType } from '@/config/enum';
import { ctxRcForm } from '@/config/config';
import FormItem from './FormItem';
import Input from '../Input';

interface IProps {
    form: any;
    msg_type: any;
    message: any;
}
function Collect({ form, msg_type, message }: IProps) {
    const { STATUS } = useSelector(
        ({ IMReducer }) => ({
            STATUS: IMReducer.STATUS
        }),
        shallowEqual
    );
    const { collect_type, err_fields } = message;
    let { info: fields } = message;
    const [submited, setSubmited] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [editable] = useState(msg_type !== 'collect_edit');
    const [btnLoading, setBtnLoading] = useState(false);
    const [btnDisable, setBtnDisable] = useState(msg_type !== 'collect_create');
    const collectConfig = getCollectConfig(collect_type);
    const formClassName = classnames({
        'im-message-form': true,
        'im-message-form-no-editable': !editable,
        'im-message-form-editable': editable
    });
    const handleChange = () => {
        if (btnDisable) {
            setBtnDisable(false);
        }
    };
    const submit = () => {
        form.validateFields(async (error, value) => {
            if (error) {
                return;
            }
            setBtnLoading(true);
            try {
                await IM.IMServer.editCollect({ collect_type, fields: value });
                IM.Toast.success({ content: '提交成功' });
                setSubmited(true);
            } catch (err) {
                IM.IMServer.notice('error', err?.data?.e || err);
            } finally {
                setBtnLoading(false);
            }
        });
    };

    useEffect(() => {
        if (form) {
            if (msg_type === 'collect_create') fields = {};
            form.setFieldsValue(fields);
        }
    }, [fields, msg_type]);

    useEffect(() => {
        if (STATUS.status === IMSTATUS.ENDED) {
            setBtnDisable(true);
            setDisabled(true);
        }
    }, [STATUS.status]);

    useEffect(() => {
        if (submited) {
            setBtnDisable(true);
        }
    }, [submited]);

    const getValidateStatus = (key) =>
        useMemo(() => {
            if (disabled) {
                return '';
            }
            if (msg_type === 'collect_reject') {
                if (_.includes(err_fields, key)) return 'warning';
            }
            return '';
        }, [key, msg_type, err_fields, disabled]);

    const getDisabled = (key) =>
        useMemo(() => {
            if (disabled) {
                return true;
            }
            if (msg_type === 'collect_reject') {
                if (!_.includes(err_fields, key)) return true;
            }
            return disabled;
        }, [key, msg_type, err_fields, disabled]);

    const btnSubmit = () => {
        if (btnLoading) {
            return <button disabled>提交中...</button>;
        }
        if (btnDisable) {
            return <button disabled>提交</button>;
        }
        return <button onClick={submit}>提交</button>;
    };

    return (
        <div className={formClassName}>
            <div className="im-message-form-title">请填写以下信息</div>
            <div className="im-message-form-content">
                <ctxRcForm.Provider value={{ form }}>
                    {collectConfig?.fields?.map(
                        ({ label, key, require, length, placeholder, rules }) => (
                            <FormItem
                                label={label}
                                rules={[
                                    require && {
                                        required: true,
                                        validator: (rule, value) => _.trim(value) !== '',
                                        message: placeholder
                                    },
                                    ...(rules || [])
                                ].filter(Boolean)}
                                required={require}
                                name={key}
                                validatestatus={getValidateStatus(key)}
                            >
                                <Input
                                    // eslint-disable-next-line jsx-a11y/aria-role
                                    role="input"
                                    name={key}
                                    disabled={!editable || getDisabled(key)}
                                    maxLength={length}
                                    placeholder={placeholder}
                                    onChange={handleChange}
                                    readOnly={submited}
                                    allowclear={msg_type === 'collect_create'}
                                />
                            </FormItem>
                        )
                    )}
                    {editable && btnSubmit()}
                </ctxRcForm.Provider>
            </div>
        </div>
    );
}

const RcForm = createForm()(Collect);

export default RcForm;
